import { compareProtoIdsByAlias } from '../util.js';

/**
 * @typedef {Object} InventoryItem
 * @property {number} id
 * @property {number} protoId
 * @property {number} amount
 */

/**
 * @param {InventoryItem} itemA
 * @param {InventoryItem} itemB
 * @returns {number}
 */
 export function compareInventoryItems(itemA, itemB) {
  return compareProtoIdsByAlias(itemA.protoId, itemB.protoId);
}

 export class InventoryItemData {
  /**
   * @param {number} id
   * @param {number} amount
   */
  constructor(id, amount) {
    this.id     = id;
    this.amount = amount;
  }
}
